import React from 'react'
import {Route, Switch} from 'react-router-dom'
import 'antd/dist/antd.css';
import 'styles/App.less'

import CartDrawer from 'modules/AppHeader/CartDrawer'
import CookiesHandler from 'components/CookiesHandler'
import Routes from './Routes'
import RoutesNav from './RoutesNavbar'
import Checkout from 'modules/Checkout'
import Footer from 'modules/Footer'

const App = () => (
  <div className="App">
    <Switch>
      <Route path='/checkout' component={Checkout}/>

      <Route>
        <header>
          <RoutesNav/>
        </header>

        <section>
          <Routes/>
        </section>

        <CartDrawer/>
      </Route>
    </Switch>

    <Footer/>

    <CookiesHandler/>
  </div>
)

export default App
